import { memo, useContext, useState, useEffect } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";

const InputEmail = memo(({ label, require, placeholder, check }) => {
  const { inputs, setInputs, errors, setErrors } = useContext(Data);
  const [checkValue, setCheckValue] = useState("");
  const emailPattern =
    /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;

  const onChange = (e) => {
    setInputs({ ...inputs, email: e.target.value });
    if (e.target.value.length > 0) {
      if (!emailPattern.test(e.target.value)) {
        setErrors({
          ...errors,
          email: "*メールアドレスの形式が正しくありません",
        });
      } else {
        setErrors({ ...errors, email: null });
      }
    } else if (require) {
      setErrors({ ...errors, email: "*必須" });
    }
  };

  useEffect(() => {
    if (check) {
      if (checkValue.length > 0) {
        if (inputs.email !== checkValue) {
          setErrors({ ...errors, emailCheck: "*メールアドレスが一致しません" });
        } else {
          setErrors({ ...errors, emailCheck: null });
        }
      } else {
        setErrors({ ...errors, emailCheck: "*必須" });
      }
    }
  }, [inputs.email, checkValue]);

  return (
    <>
      <label className={styles.labelCommon}>
        <p className="bold">
          {label}
          <span>{errors.email}</span>
        </p>
        <input
          type="email"
          name="email"
          value={inputs.email}
          onChange={onChange}
          placeholder={placeholder}
        />
      </label>
      {check ? (
        <>
          <label className={styles.labelCommon}>
            <p className="bold">
              {label}(確認)
              <span>{errors.emailCheck}</span>
            </p>
            <input
              type="email"
              value={checkValue}
              onChange={(e) => setCheckValue(e.target.value)}
              placeholder={placeholder}
            />
          </label>
        </>
      ) : (
        <></>
      )}
    </>
  );
});

export default InputEmail;
